var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 16.2099C2.15833 16.2099 1.771 16.0559 1.463 15.7479C1.15433 15.4393 1 15.0516 1 14.5849V2.20994H0V1.20994H4V0.434937H10V1.20994H14V2.20994H13V14.5849C13 15.0516 12.846 15.4393 12.538 15.7479C12.2293 16.0559 11.8417 16.2099 11.375 16.2099H2.625ZM12 2.20994H2V14.5849C2 14.7516 2.06267 14.8973 2.188 15.0219C2.31267 15.1473 2.45833 15.2099 2.625 15.2099H11.375C11.5417 15.2099 11.6873 15.1473 11.812 15.0219C11.9373 14.8973 12 14.7516 12 14.5849V2.20994ZM4.8 13.2099H5.8V4.20994H4.8V13.2099ZM8.2 13.2099H9.2V4.20994H8.2V13.2099Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.31dcca957b69484657f6ace817558129.svg";
export { ForwardRef as ReactComponent };